import commonEn from './en/common';
import commonZhHans from './zh_hans/common';
import commonZhHant from './zh_hant/common';
import catGameEn from './en/cat_game';
import catGameZhHans from './zh_hans/cat_game';
import catGameZhHant from './zh_hant/cat_game';
import teethEn from './en/teeth';
import teethZhHans from './zh_hans/teeth';
import teethZhHant from './zh_hant/teeth';
import blackWhiteEn from './en/black_white';
import blackWhiteZhHans from './zh_hans/black_white';
import blackWhiteZhHant from './zh_hant/black_white';
import areaVolumeEn from './en/area_volume';
import areaVolumeZhHans from './zh_hans/area_volume';
import areaVolumeZhHant from './zh_hant/area_volume';
import nineCutEn from './en/nine_cut';
import nineCutZhHans from './zh_hans/nine_cut';
import nineCutZhHant from './zh_hant/nine_cut';
import aiHeartSafeEn from './en/aiheartsafe';
import aiHeartSafeZhHans from './zh_hans/aiheartsafe';
import aiHeartSafeZhHant from './zh_hant/aiheartsafe';
import todayRateEn from './en/today_rate';
import todayRateZhHans from './zh_hans/today_rate';
import todayRateZhHant from './zh_hant/today_rate';
import mindayEn from './en/minday';
import mindayZhHans from './zh_hans/minday';
import mindayZhHant from './zh_hant/minday';

export default {
  en: {
    common: commonEn,
    catGame: catGameEn,
    teeth: teethEn,
    blackWhite: blackWhiteEn,
    areaVolume: areaVolumeEn,
    nineCut: nineCutEn,
    aiHeartSafe: aiHeartSafeEn,
    todayRate: todayRateEn,
    minday: mindayEn,
  },
  zh: {
    common: commonZhHans,
    catGame: catGameZhHans,
    teeth: teethZhHans,
    blackWhite: blackWhiteZhHans,
    areaVolume: areaVolumeZhHans,
    nineCut: nineCutZhHans,
    aiHeartSafe: aiHeartSafeZhHans,
    todayRate: todayRateZhHans,
    minday: mindayZhHans,
  },
  'zh-CN': {
    common: commonZhHans,
    catGame: catGameZhHans,
    teeth: teethZhHans,
    blackWhite: blackWhiteZhHans,
    areaVolume: areaVolumeZhHans,
    nineCut: nineCutZhHans,
    aiHeartSafe: aiHeartSafeZhHans,
    todayRate: todayRateZhHans,
    minday: mindayZhHans,
  },
  'zh-HK': {
    common: commonZhHant,
    catGame: catGameZhHant,
    teeth: teethZhHant,
    blackWhite: blackWhiteZhHant,
    areaVolume: areaVolumeZhHant,
    nineCut: nineCutZhHant,
    aiHeartSafe: aiHeartSafeZhHant,
    todayRate: todayRateZhHant,
    minday: mindayZhHant,
  },
  'zh-TW': {
    common: commonZhHant,
    catGame: catGameZhHant,
    teeth: teethZhHant,
    blackWhite: blackWhiteZhHant,
    areaVolume: areaVolumeZhHant,
    nineCut: nineCutZhHant,
    aiHeartSafe: aiHeartSafeZhHant,
    todayRate: todayRateZhHant,
    minday: mindayZhHant,
  },
}
